@if (color) {
    <section id="tag" [class]="'flex h-6 w-16 p-2 justify-center items-center rounded-lg whitespace-nowrap border neutrals-grey-03-border'" [ngStyle]="{'background-color': color === Colors.TRANSPARENT ? 'transparent' : color}"></section>
} @else {
    <section id="tag" [class]="'flex h-6 font-bold p-2 justify-center items-center rounded-lg whitespace-nowrap'">-</section>
}